export default __webpack_public_path__ + "parking_lot_background.68e3d36b.png";